type Param = string | undefined;

type UTMParamsT =
  | "utm_campaign"
  | "utm_content"
  | "utm_medium"
  | "fbuy_ref_code"
  | "utm_source"
  | "utm_term";

type UTMParams = { [key in UTMParamsT]: string };

type LastTouchParams = {
  lastTouchUtmCampaign: Param;
  lastTouchUtmMedium: Param;
  lastTouchUtmSource: Param;
  lastTouchUtmContent: Param;
  lastTouchUtmTerm: Param;
  lastTouchReferrer: Param;
  lastTouchReferrerDomain: Param;
  lastTouchUtmMerchantCode1: Param;
};

type AnyParams = {
  mostRecentLeadSourceDetail: Param;
  mostRecentLeadSource: Param;
};

export type AllUtmParams = LastTouchParams & AnyParams;

const getUrlParams = (param: UTMParamsT, urlParams: URLSearchParams) =>
  urlParams.get(param) ?? "none";

// if there are no UTM params,
const setDirectValues = (obj: UTMParams): UTMParams =>
  Object.keys(obj).reduce(
    (acc, key) => ({ ...acc, [key]: "direct" }),
    {} as UTMParams
  );

const everyValueNone = (obj: UTMParams) =>
  Object.values(obj).every((val) => val === "none");

const getUTMParams = (): UTMParams => {
  const queryString = window?.location?.search;
  const urlParams = new URLSearchParams(queryString);
  const utmParams: UTMParams = {
    fbuy_ref_code: getUrlParams("fbuy_ref_code", urlParams),
    utm_campaign: getUrlParams("utm_campaign", urlParams),
    utm_content: getUrlParams("utm_content", urlParams),
    utm_medium: getUrlParams("utm_medium", urlParams),
    utm_source: getUrlParams("utm_source", urlParams),
    utm_term: getUrlParams("utm_term", urlParams),
  };

  // no UTM values
  if (everyValueNone(utmParams)) {
    return setDirectValues(utmParams);
  }
  return utmParams;
};

const lastTouchParams: LastTouchParams = {
  lastTouchUtmCampaign: "",
  lastTouchUtmMedium: "",
  lastTouchUtmSource: "",
  lastTouchUtmContent: "",
  lastTouchUtmTerm: "",
  lastTouchReferrer: "",
  lastTouchReferrerDomain: "",
  lastTouchUtmMerchantCode1: "",
};

const getReferrerDomain = (): string => {
  const referrerMatch = document?.URL?.match(
    // pulls out referrer with http/s -> source https://regex101.com/r/MOIFTy/3
    /^(?:https?:)?(?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/
  );
  return referrerMatch ? referrerMatch[0] : "none";
};

const getReferrer = (): string => document?.referrer ?? "none";

export const getLastTouchUTMParams = (
  params: LastTouchParams
): LastTouchParams => {
  const utmParams = getUTMParams();
  params.lastTouchReferrer = getReferrer();
  params.lastTouchReferrerDomain = getReferrerDomain();
  params.lastTouchUtmCampaign = utmParams.utm_campaign;
  params.lastTouchUtmContent = utmParams.utm_content;
  params.lastTouchUtmMedium = utmParams.utm_medium;
  params.lastTouchUtmMerchantCode1 = utmParams.fbuy_ref_code;
  params.lastTouchUtmSource = utmParams.utm_source;
  params.lastTouchUtmTerm = utmParams.utm_term;
  return params;
};

export const getAllUtmParams = (): AllUtmParams => ({
  ...getLastTouchUTMParams(lastTouchParams),
  mostRecentLeadSourceDetail: "Inbound - Self Serve",
  mostRecentLeadSource: "Inbound - Self Serve",
});
